import React, { Component } from 'react';
import { connect } from 'react-redux';

import Sticky from 'Components/Sticky';
import TransportersList from 'Components/TransportersList';
import TransportersTableHeader from 'Components/TransportersTableHeader';
import { GET_GROUPS, GET_TRANSPORTERS} from 'Constants/actionConstants';
import GroupContainer from 'Components/TransportersCard/GroupContainer';
import SubHeading from 'Components/SubHeading';
import ConfirmationPopup from 'Components/ConfirmationPopup';
import { CREATE_GROUP, EDIT_GROUP, STATUS_GROUP } from 'Constants/actionConstants';

import { getUser } from 'Utils/storage';

import { ReactComponent as CloseIcon } from 'Icons/cancel.svg';
import {ReactComponent as EditActiveIcon} from 'Icons/pencil-edit-active-button.svg';
import {ReactComponent as EditIcon} from 'Icons/pencil-edit-button.svg';
import { DELETE_GROUP, GET_BRANCHES } from 'Constants/actionConstants';
import { PROVIDER_TYPES } from 'Constants/commonConstants';


class GroupAndTransporters extends Component {
    state= {
        isDeleteConfirmationPopupShown: false,
        editingGroup: null,
        isAdding: false,
        editedName: {},
        branchIdList:null,
        isMultimode: false,
        isExim: false
        
    }
    showDeleteConfirmationPopup = (group)=> {
        this.setState({
            groupToBeDeleted: group
        })
        this.setState({
            isDeleteConfirmationPopupShown: true
        })
    }
    hideDeleteConfirmationPopup = ()=> {
        this.setState({
            isDeleteConfirmationPopupShown: false
        })
    }
    getGroups = ()=> {
        const { dispatch, match } = this.props;
        dispatch({
            type: GET_GROUPS,
            params: {
                type: match.params.type,
                isMultimode: this.state.isMultimode,
                isExim: this.state.isExim
            }    
        })
    }
    getTransporters = (filters)=> {
        const user = getUser();
        const { dispatch, match } = this.props;
        const data = {
            companyId:user.companyId,
            branchId:user.branchId,
            type: match.params.type || 2,
            isMultimode: this.state.isMultimode,
            isExim: this.state.isExim,
            ...filters
        }
        dispatch({
            type: GET_TRANSPORTERS,
           // params: {
               // ...filters
            //},
            data
        })
    }
    getBranches = () => {
        const { dispatch } = this.props;
        const user = getUser();
        dispatch({
            type: GET_BRANCHES,
            data: {
              companyId: user.id
            }
        })
    }
    deleteGroup = ()=> {
        const { dispatch, match } = this.props;
        this.hideDeleteConfirmationPopup();
        dispatch({
            type: DELETE_GROUP,
            params: {
                id: this.state.groupToBeDeleted.id,
                type: match.params.type
            },
            onSuccess: this.getGroups
        })
    }
    createGroup = (name, transporters, branches)=> {
        const { dispatch, match } = this.props;
        dispatch({
            type: CREATE_GROUP,
            data: {
                name,
                branch_id:branches,
                type: match.params.type,
                transporters: transporters.map((transporter)=> {
                    return transporter.getApiData();
                }),
                is_multimode: this.state.isMultimode,
                is_exim: this.state.isExim
            },
            onSuccess: this.getGroups
        })
    }
    editGroup = (transporters=[])=> {
        const { dispatch, groups, match } = this.props;
        const { editingGroup, editedName ,branchIdList} = this.state;
        const selGroup = groups.filter((group) => { return group.id === editingGroup })[0];
        const mergedArr = transporters.concat(selGroup.transporters); 
        const consolidatedTransporterList = mergedArr.filter((ele, index) =>  mergedArr.indexOf(ele) === index);

        const name = (editedName && Object.keys(editedName).length > 0 && (editedName[editingGroup].trim() !== selGroup.name.trim())) ? editedName[editingGroup] : selGroup.name;

        if (transporters.length > 0 || editedName !== selGroup.name) {
            dispatch({
                type: EDIT_GROUP,
                data: {
                    id: editingGroup,
                    name: name,
                    branch_id:branchIdList,
                    type: match.params.type,
                    transporters: (transporters.length <= 0) ? selGroup.transporters : consolidatedTransporterList.map((transporter)=> {
                        return transporter.getApiData();
                    }),
                    is_multimode: this.state.isMultimode,
                    is_exim: this.state.isExim
                },
                onSuccess: () => {
                    this.setState({ editingGroup: null, isAdding: false });
                    this.getGroups();
                }
            });
            return;
        } 
        if (transporters.length <= 0){
            this.showDeleteConfirmationPopup(selGroup);
        }
    }
    selectEditingGroup = (group) => {
        if (group && group.id) {
            this.setState({
                editingGroup: (group.id !== this.state.editingGroup) ? group.id : null,
                branchIdList: group.branch_Id
            });
        }
    }
    
    branchModified=(branchId)=>{
        this.setState({
            branchIdList:branchId
        }, this.editGroup)
    }

    nameModified = (name) => {
        const { editedName, editingGroup } = this.state;
        editedName[editingGroup] = name;
        this.setState({
            editedName
        }, () => {
            // this.editGroup([], true);
        });
    }
    removeTransporterFromGroup = (transporterId) => {
        if (transporterId) {
            const selGroup = (this.props.groups || []).filter((group) => { return group.id === this.state.editingGroup });
            let transportersList = selGroup[0] ? selGroup[0].transporters : [];
            const selTransporter = transportersList.filter((transporter) => { return transporter.id === transporterId });
            const transporterIndex = transportersList.findIndex((transporter)=> {
                return transporter.id === transporterId;
            });
            if(transporterIndex > -1) {
                transportersList.splice(transporterIndex, 1);
            }
            this.editGroup(transportersList);
        }
    }

    getHeader = () => {
        const { match } = this.props;
        return (PROVIDER_TYPES.find(pType => pType.value === (match.params && +match.params.type)) || {}).name;
    }
    
    activeOrdeactivatedTransporter=(groupId, transporterId, status)=>{
       console.log("hey",groupId, transporterId, status);
      const { dispatch } = this.props;

        dispatch({
           type: STATUS_GROUP,
           data: {
               id: groupId,
               transporterId:transporterId,
               status:status
                 },
          onSuccess: () => {
          this.getGroups();
           }
          });
    }

    checkMutiMode = (multi, exim) => {
        const { isMultimode } = this.state;
        this.setState({ isMultimode: multi, isExim: exim }, () => {
            this.getTransporters();
            this.getGroups();
        });
    }

    render() {
        const { groups, transporters, branchesList, match } = this.props;
        return (
            <Sticky>
                <div className="mt-50 flex pl-15 pr-15">
                    {
                        this.state.isDeleteConfirmationPopupShown && 
                        <ConfirmationPopup 
                            onCancel={this.hideDeleteConfirmationPopup} text="Are you sure you want to delete the group"
                            onConfirm={this.deleteGroup}
                        />
                    }
                    <div className="mr-50">
                        <TransportersList 
                            createGroup={this.createGroup} 
                            editGroup={this.editGroup}
                            branchesList={branchesList}
                            transporters={transporters || []}
                            fetchTransporters = {this.getTransporters}
                            editingGroup={this.state.editingGroup}
                            branchIdList={this.state.branchIdList}
                            header={this.getHeader()}
                            isMultimode={this.state.isMultimode}
                            checkMutiMode={this.checkMutiMode}
                            providerType={match.params && +match.params.type}
                            isExim={this.state.isExim}
                        />
                    </div>
                    <div>
                        <SubHeading text="My Groups" className=""/>
                        <div className="flex flex-wrap">
                            {groups.map((group, index)=> {
                                const EditIconRenderer = (this.state.editingGroup === group.id) ? EditActiveIcon:EditIcon;
                                return (
                                    <div className="mr-40 min-wt-350 br-5 pr mb-20" key={`${index + 1}`}>
                                        <EditIconRenderer className="pa r-40 t-4 curP t-30 wt-20 ht-18" onClick={this.selectEditingGroup.bind(this, group)}  />
                                        <CloseIcon className="pa r-10 t-4 curP t-30 wt-18 ht-18" onClick={this.showDeleteConfirmationPopup.bind(this, group)}/>
                                        <GroupContainer group={group} selectedList={true} editingGroup={this.state.editingGroup} removeTransporterFromGroup={this.removeTransporterFromGroup} nameModified={this.nameModified} branchModified={this.branchModified}  branchesList={branchesList} activeOrdeactivatedTransporter={this.activeOrdeactivatedTransporter} viewMode={true} providerType={match.params && +match.params.type}/>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </Sticky>
        );
    }
    componentDidMount() {
        localStorage.removeItem('branchDetail');
        this.getGroups();
        this.getTransporters();
        this.getBranches();
    } 
}

const mapStateToProps = ({constants}) => {
  return {
      transporters: constants.transporters,
      branchesList: constants.branchesList,
      groups: constants.groups,
  }
};


export default connect(mapStateToProps)(GroupAndTransporters);
